export default function isLocal(path) {
  return /^(https?:)?\/\/localhost($|[/:])/.test(path)
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/isLocal.js